import { render, staticRenderFns } from "./ContentRight.vue?vue&type=template&id=251987ae&scoped=true&"
import script from "./ContentRight.vue?vue&type=script&lang=js&"
export * from "./ContentRight.vue?vue&type=script&lang=js&"
import style0 from "./ContentRight.vue?vue&type=style&index=0&id=251987ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251987ae",
  null
  
)

export default component.exports